import React from 'react';
import LeftBar from '../../Components/LeftBar';
import Dashnav from '../../Components/Dashnav';
import VendorSectionComp from './VendorSectionComp';

function VendorSectionPage({ section }) {
  return (
    <div className="mainContainer">
      <LeftBar />
      <div className="theMainContainer">
        <Dashnav />
        <VendorSectionComp section={section} />
      </div>
    </div>
  );
}

export default VendorSectionPage;
